exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".poster-viewer{background-size:contain;background-position:center;background-repeat:no-repeat;top:0;left:0;bottom:0;right:0;position:absolute;z-index:1;transition:opacity .5s}.poster-viewer--is-hidden{opacity:0;visibility:hidden}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/containers/poster/style.scss
// module id = 334
// module chunks = 0